var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-fab-transition',[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.fab),expression:"fab"}],attrs:{"name":"btn_back_to_top","id":"btn_back_to_top","fab":"fab","small":"","fixed":"","bottom":"","right":"","color":"primary"},on:{"click":_vm.toTop}},[_c('v-icon',[_vm._v("keyboard_arrow_up")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }